import { Lkup_Inst_Cnd } from '../models/domain/lkup_inst_cnd';
import { Util } from './util';

export class Lkup_Inst_CndUtil {
    private static instance: Lkup_Inst_CndUtil;

    static getInstance(): Lkup_Inst_CndUtil {
        if (!Lkup_Inst_CndUtil.instance) {
            Lkup_Inst_CndUtil.instance = new Lkup_Inst_CndUtil();
        }
        return Lkup_Inst_CndUtil.instance;
    }

    /**
    * Lkup_Inst_CndUtil is a singleton class, so use Lkup_Inst_CndUtil.getInstance() method instead of creating new Lkup_Inst_CndUtil().
    */
    private constructor() {

    }

    copy(lkup_Inst_Cnds: Array<Lkup_Inst_Cnd>): Array<Lkup_Inst_Cnd> {
        let lkup_Inst_CndsTmp: Array<Lkup_Inst_Cnd> = Array<Lkup_Inst_Cnd>();

        for (let i: number = 0; i < lkup_Inst_Cnds.length; i++) {
            let lkup_Inst_CndTmp: Lkup_Inst_Cnd = lkup_Inst_Cnds[i] as Lkup_Inst_Cnd;
            lkup_Inst_CndsTmp.push(lkup_Inst_CndTmp)
        }
        return lkup_Inst_CndsTmp;
    }

    copyFrom(lkup_Inst_Cnds: Array<Lkup_Inst_Cnd>, lkup_Inst_CndsTmp: Array<Lkup_Inst_Cnd>): void {
        let lkup_Inst_CndsMap: Map<number, Lkup_Inst_Cnd> = new Map();

        for (let i: number = 0; i < lkup_Inst_Cnds.length; i++) {
            let lkup_Inst_Cnd: Lkup_Inst_Cnd = lkup_Inst_Cnds[i] as Lkup_Inst_Cnd;
            lkup_Inst_CndsMap.set(lkup_Inst_Cnd.dxMp_Id, lkup_Inst_Cnd);
        }

        lkup_Inst_Cnds.splice(0, lkup_Inst_Cnds.length);

        for (let i: number = 0; i < lkup_Inst_CndsTmp.length; i++) {
            let lkup_Inst_CndTmp: Lkup_Inst_Cnd = lkup_Inst_CndsTmp[i] as Lkup_Inst_Cnd;

            let lkup_Inst_Cnd: Lkup_Inst_Cnd = lkup_Inst_CndsMap.get(lkup_Inst_CndTmp.dxMp_Id);
            if (lkup_Inst_Cnd) {
                lkup_Inst_Cnd.copyFrom(lkup_Inst_CndTmp);
            } else {
                lkup_Inst_Cnd = Lkup_Inst_Cnd.parse(lkup_Inst_CndTmp);
            }

            lkup_Inst_Cnds.push(lkup_Inst_Cnd);
        }
    }

    compare(lkup_Inst_Cnds: Array<Lkup_Inst_Cnd>, lkup_Inst_CndsTmp: Array<Lkup_Inst_Cnd>): string {
        let lkup_Inst_CndsLength = lkup_Inst_Cnds.length;
        let lkup_Inst_CndsTmpLength = lkup_Inst_CndsTmp.length;

        if (lkup_Inst_CndsLength != lkup_Inst_CndsTmpLength) {
            return 'lkup_Inst_Cnds length is different.';
        }

        let lkup_Inst_CndCopyMap: Map<number, Lkup_Inst_Cnd> = new Map();
        for (let i: number = 0; i < lkup_Inst_CndsTmpLength; i++) {
            let lkup_Inst_CndsCopy: Lkup_Inst_Cnd = lkup_Inst_CndsTmp[i] as Lkup_Inst_Cnd;
            lkup_Inst_CndCopyMap.set(lkup_Inst_CndsCopy.lkup_Inst_Cnd_Id, lkup_Inst_CndsCopy);
        }

        for (let i: number = 0; i < lkup_Inst_CndsLength; i++) {
            let lkup_Inst_Cnd: Lkup_Inst_Cnd = lkup_Inst_Cnds[i] as Lkup_Inst_Cnd;

            let lkup_Inst_CndCopy: Lkup_Inst_Cnd = lkup_Inst_CndCopyMap.get(lkup_Inst_Cnd.lkup_Inst_Cnd_Id);

            if (!lkup_Inst_CndCopy) {
                return lkup_Inst_Cnd.lkup_Inst_Cnd_Id + ' is found in copy.'
            }

            if (lkup_Inst_Cnd.compare(lkup_Inst_CndCopy) != '') {
                return lkup_Inst_Cnd.lkup_Inst_Cnd_Id + ' is not equal.'
            }
        }

        return '';
    }

    toString(lkup_Inst_Cnds: Array<Lkup_Inst_Cnd>): string {
        let str: string = '';

        for (let i: number = 0; i < lkup_Inst_Cnds.length; i++) {
            let lkup_Inst_CndTmp: Lkup_Inst_Cnd = lkup_Inst_Cnds[i] as Lkup_Inst_Cnd;
            str += lkup_Inst_CndTmp.toString();
        }

        return str;
    }

    packLkup_Inst_Cnd_Ids(list, field, objectWrapper) {
        if (!list) return;

        for (let i = 0; i < list.length; i++) {
            let util: Util = Util.getInstance();
            let fieldValue = util.readDotStringNotation(list[i], field);
            objectWrapper.lkup_Inst_Cnd_IdsHMap[fieldValue] = list[i];
        }
    }
}